import { render } from "./RemunerationManagement.vue?vue&type=template&id=0a8cb431&scoped=true"
import script from "./RemunerationManagement.vue?vue&type=script&lang=js"
export * from "./RemunerationManagement.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-0a8cb431"

export default script